import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import api from './api/api'; // Ensure the path is correct
import Login from './components/Login';
import Layout from './components/Layout';
import DocumentPage from './components/Document';

export default function App() {
  const [user, setUser] = useState(null);
  const [profileFetched, setProfileFetched] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await api.get('/users/profile');
        setUser(res.data);
      } catch {
        setUser(null);
      } finally {
        setProfileFetched(true);
      }
    };

    fetchProfile();
  }, []);

  if (!profileFetched) {
    return (
      <div className="min-h-screen flex items-center justify-center text-green-700">
        Wczytywanie...
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {user ? (
          <>
            <Route
              path="/*"
              element={
                <Layout
                  user={user}
                  onLogout={async () => {
                    try {
                      await api.post("/auth/logout");
                      setUser(null);
                    } catch (err) {
                      console.error("Logout failed:", err);
                    }
                  }}
                />
              }
            />
            <Route path="/document/:id" element={<DocumentPage />} />
          </>
        ) : (
          <Route
            path="/*"
            element={
              <Login
                onLogin={async () => {
                  try {
                    const res = await api.get('/users/profile');
                    setUser(res.data);
                  } catch {
                    setUser(null);
                  }
                }}
              />
            }
          />
        )}
      </Routes>
    </Router>
  );
}